import { ref, watch, nextTick, unref } from 'vue';
import { useReportStore } from '@/stores/report';
import { showToast } from '@tarojs/taro';
import { SYSTEM_ID, DATA_FLAG, SYSTEM_BATCH_FORM_STORAGE } from '@/constants/index.ts'
import {
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
} from '@/tool/localStore.ts';


export function useReportMethods() {
  const peportStore = useReportStore();

  // 获取所有表单的ref
  async function getRefs(refEl) {
    try {
      // 等待DOM更新完成
      await nextTick();
      const refs = unref(refEl);
      if (!Array.isArray(refs)) {
        throw new Error('refEl is not an array');
      }

      // 过滤并提取有效的refs
      const validRefs = refs
        .filter(item => Array.isArray(item) && item.length > 0)
        ?.map(item => item[0]);
      return validRefs;
    } catch (error) {
      console.error('获取ref错误:', error);
      throw error; // 抛出错误以允许调用者处理
    }
  }


  // 获取表单中的 鱼池 或者 动态表单
  // options.syncOnly = true 时，仅执行同步回调，不触发子表单的 getFishPond/getFormData 以避免覆盖本地未提交的数据
  async function getFishPond(refs, batchId, systemId, callBack, options = {}) {
    const formItem = [];
    const syncOnly = options?.syncOnly === true;

    try {
      // 顺序执行，避免并发引起的引用覆盖/多次刷新
      for (const item of refs || []) {
        const hasLoader =
          typeof item?.getFishPond === 'function' ||
          typeof item?.getFormData === 'function';

        if (syncOnly) {
          // 每个子表单同步前等待一帧，确保 v-model 已经稳定
          await nextTick();
          if (typeof callBack === 'function') {
            callBack(item);
          } else if (typeof item?.syncToReportStore === 'function') {
            item.syncToReportStore();
          } else if (typeof item?.forceSyncToStore === 'function') {
            item.forceSyncToStore();
          }
          // 同步后再等待一帧，确保 Pinia 已写入完成
          await nextTick();
        } else if (hasLoader) {
          // 正常加载模式
          item?.getFishPond?.(batchId.value, systemId.value);
          item?.getFormData?.(batchId.value, systemId.value);
          callBack?.(item);
        }

        formItem.push(item);
      }

      return formItem;
    } catch (error) {
      console.log(JSON.stringify(error));
      throw error;
    }
  }


  // 验证表单
  function validateForms(refs) {
    // 创建一个数组来存储所有的验证错误
    let allErrors = [];

    return new Promise(async (resolve, reject) => {
      for (const item of refs) {
        try {
          const { valid, errors } = await item?.formRef?.validate();

          if (!valid) {
            // 如果默认验证失败，记录错误信息但不返回
            console.log('默认表单', item);
            allErrors.push({ success: false, item, errors });
            continue;
          }



          /************验证备用代码 start**********/
          // if (item?.independentField) {
          //   let customErrors = [];
          //   let { model, modelName, data, tipsFields } = item?.independentField;
          //   console.log('data--item', data);
          //   console.log('object', item?.independentField);

          //   // 自定义验证逻辑
          //   tipsFields.forEach(rule => {
          //     const { fieldName, field, tipsLabel } = rule;
          //     // 根据规则验证 data.value 中的数据
          //     const invalidItems = data.value.filter(
          //       item => !item[field] && item.queue != 'all'
          //     );

          //     if (invalidItems.length > 0) {
          //       invalidItems.forEach(item => {
          //         const errorMessage = `${modelName}-${fieldName}-${item.fishpondCode}-${tipsLabel}不能为空`;
          //         customErrors.push({ message: errorMessage });
          //       });
          //     }
          //   });
          //   console.log('独立字段', customErrors);

          //   // 如果有自定义错误，则添加到 allErrors 数组中
          //   if (customErrors.length > 0) {
          //     allErrors.push({
          //       success: false,
          //       item: { name: model },
          //       errors: customErrors,
          //     });
          //   }
          // }
          /************验证备用代码 end**********/



        } catch (error) {
          console.error('验证过程中发生错误 1111:', error);
          allErrors.push({ success: false, item, error });
          reject(allErrors)

        }
      }

      // 最后根据 allErrors 判断是否全部成功
      if (allErrors.length === 0) {
        resolve({ success: true })
      } else {
        // 返回第一个验证失败的结果（保持原始格式）
        resolve(allErrors[0])
      }
    })
  }


  // 检测一个对象中是否有值，可以排除指定属性
  function validateAndReturnObject(obj, excludeFields = []) {
    // 确保传入的是一个有效的对象
    if (typeof obj !== 'object' || obj === null) {
      return null;
    }

    // 创建 Set 用于快速查找排除字段
    const excludeSet = new Set(excludeFields);

    // 遍历对象的键值对
    for (const key of Object.keys(obj)) {
      // 如果当前键不在排除列表中，并且对应的值不是空，则返回对象
      if (!excludeSet.has(key) && obj[key] != null && obj[key] !== '') {
        return obj;
      }
    }

    // 如果没有找到任何非空字段，返回 null
    return null;
  }

  // 提交后清空数据
  function sbmitResetForm(data, refs) {
    let { batchId, systemId } = data;
    let reSetForm = refs[0]?.reSetForm
    peportStore.resetData(batchId, systemId)
  }

  // 删除图片和存储图片操作
  function OperationImage(data) {
    const { type, data: dataOrIndex, formName } = data;
    const getData = (type) => {
      let res = peportStore.optionsFiles('get', [], type)

      return res
    };
    if (type === 'get') return getData(formName);
    if (type === 'set') {
      peportStore.optionsFiles(type, dataOrIndex, formName);
    }

    if (type === 'del') {

      // let _delData = getData(formName).splice(dataOrIndex, 1);
      // peportStore.optionsFiles(type, _delData, formName);


    }


  };

  // 设置数据暂存
  function dataTemporaryStorage(type = 'set') {
    // 读取是否选择了上报类型
    let dataFlag = getLocalStorage(DATA_FLAG);
    // 设置数据暂存
    if (type == 'set') {
      if (dataFlag?.length) {
        // 设置当前批次 系统 到本地，便于下次读取去替换对应的数据
        let selectedContext = peportStore.getSelectedContext;
        setLocalStorage(SYSTEM_ID, selectedContext);
        // 获取当前批次 系统的数据详情
        let getBatchSystemData = peportStore.fetchDataByBatchAndSystem();
        setLocalStorage(SYSTEM_BATCH_FORM_STORAGE, getBatchSystemData);
        // 提示暂存成功
        showToast({
          title: '已暂存',
          duration: 2000,
        });
      } else {
        showToast({
          title: '暂存数据为空',
          icon: 'error',
          duration: 2000,
        });
      }
    }

    // 获取数据暂存
    if (type == 'get') {
      // 上报类型有数据表示有暂存 SYSTEM_ID
      if (dataFlag?.length) {
        // 获取缓存批次 id 系统 id  code 等，设置到pinia中
        let getBatchSystemId = getLocalStorage(SYSTEM_ID);
        const { batchId, systemId, batchCode, systemCode } = getBatchSystemId;
        peportStore.setCurrentSelectTarget(getBatchSystemId)
        // 获取缓存批次 系统 表单详情以及设置
        let getBatchSystemData = getLocalStorage(SYSTEM_BATCH_FORM_STORAGE);
        peportStore.loadAndReplaceCachedFormData(batchId, systemId, getBatchSystemData)
        return {
          hasCache: Boolean(dataFlag?.length),
          peportTypeContnet: dataFlag,
          prportypeValue: dataFlag?.map(item => item.value),
          batchSystemData: getBatchSystemData,
          batchId,
          batchCode,
          systemId,
          systemCode
        }
      }
    }
    // 移除数据暂存
    if (type == 'clear') {
      removeLocalStorage(SYSTEM_ID);
      removeLocalStorage(DATA_FLAG);
      removeLocalStorage(SYSTEM_BATCH_FORM_STORAGE);
    }
  };

  return {
    getRefs,
    getFishPond,
    validateForms,
    validateAndReturnObject,
    sbmitResetForm,
    OperationImage,
    dataTemporaryStorage
  }


}